import {
  AccordionItem,
  DefinitionList,
  DefinitionListItem,
  DefinitionTerm,
  DefinitionValue,
} from "@apex/component-library";
import { HStack, Stack, Text } from "@chakra-ui/react";
import { DateTime } from "luxon";

import { CallDetailResultFromAPI } from "../../types";
import { DISPLAY_DATE_FORMAT } from "../../utils/dateFormatter";
import { Currency, formatCurrency } from "../../utils/formatCurrency";

type Props = {
  entry: CallDetailResultFromAPI;
  entryIndex: number;
  handleClick: (index: number) => void;
};

export default function EventItem({ handleClick, entry, entryIndex }: Props) {
  const {
    callAmount,
    description,
    dueDate,
    eventCode,
    eventName,
    eventType,
    issueDate,
    tradeDate,
  } = entry;

  const getFormattedDate = (date: string) => {
    return DateTime.fromISO(date, { setZone: true }).toFormat(
      DISPLAY_DATE_FORMAT
    );
  };

  return (
    <AccordionItem
      data-testid="event-item"
      headerText={
        <HStack fontWeight={400}>
          <Text w="15%" data-testid="event-type" textTransform="capitalize">
            {eventType?.toLocaleLowerCase()}
          </Text>
          <Text w="10%" data-testid="event-code">
            {eventCode}
          </Text>
          <Text w="30%" data-testid="event-name">
            {eventName}
          </Text>
          <Text
            w={eventType === "CALL" ? "15%" : "37%"}
            data-testid="description"
            isTruncated
          >
            {description}
          </Text>
          {eventType === "CALL" && (
            <Text w="30%" data-testid="call-amount" textAlign="end">
              {
                <>
                  {formatCurrency(
                    Currency.Usd,
                    callAmount ? String(callAmount) : null
                  )}
                </>
              }
            </Text>
          )}
        </HStack>
      }
      variant="gray"
      onClick={() => handleClick(entryIndex)}
    >
      <Stack pl={10} spacing={8} pb={8}>
        <DefinitionList>
          <DefinitionListItem>
            <DefinitionTerm fontWeight="bold" w="160px">
              Trade Date
            </DefinitionTerm>
            <DefinitionValue>{getFormattedDate(tradeDate)}</DefinitionValue>
          </DefinitionListItem>
          <DefinitionListItem>
            <DefinitionTerm fontWeight="bold" w="160px">
              Due Date
            </DefinitionTerm>
            <DefinitionValue>{getFormattedDate(dueDate)}</DefinitionValue>
          </DefinitionListItem>
          <DefinitionListItem>
            <DefinitionTerm fontWeight="bold" w="160px">
              Issue Date
            </DefinitionTerm>
            <DefinitionValue>{getFormattedDate(issueDate)}</DefinitionValue>
          </DefinitionListItem>
        </DefinitionList>
      </Stack>
    </AccordionItem>
  );
}
